import type { ContentItem } from '../api/apiClient'
import { toNewsCardItem, type NewsCardItem } from '../utils/content'

const FALLBACK_CONTENT: ContentItem[] = [
  {
    id: 'fallback-news-1',
    slug: 'dispatches-from-excavations',
    title: 'Dispatches from Active Excavations',
    summary: 'Weekly correspondents surface context from digs, court records, and museum releases.',
    body: `Trenches at Vindolanda and Silchester are yielding new organic finds even in late-season mud. Our field writers are
shadowing the conservation crews to chart how each discovery moves from soil, to tent, to lab bench.

Every Friday, we publish dig notes alongside translation snippets so teachers can fold them into term plans immediately.`,
    published_at: '2025-12-05T09:00:00Z',
    metadata: {
      place_slug: 'vindolanda',
      place_name: 'Vindolanda Roman Fort',
    },
    hero_image: 'https://images.unsplash.com/photo-1473773508845-188df298d2d1?auto=format&fit=crop&w=1200&q=60',
    related_places: ['vindolanda'],
  },
  {
    id: 'fallback-news-2',
    slug: 'policy-shifts-that-reshape-heritage',
    title: 'Policy Shifts that Reshape Heritage',
    summary: 'Track how funding rounds, stewardship debates, and access pilots change visiting rights.',
    body: `A fresh round of lottery grants has been earmarked for community-run archives, but only if councils can prove
their sites host at least one educational residency per season. We break down the fine print so parish stewards know
what evidence to gather before the spring review.

Policy desks in Edinburgh and Cardiff confirmed that temporary closures will be logged publicly going forward. That
means trail planners finally gain a single dashboard for anticipating detours.`,
    published_at: '2025-12-02T08:00:00Z',
    metadata: {
      expiry_date: '2025-12-15T00:00:00Z',
      place_slug: 'edinburgh-castle',
      place_name: 'Edinburgh Castle',
    },
    hero_image: 'https://images.unsplash.com/photo-1505843513577-22bb7d21e455?auto=format&fit=crop&w=1200&q=60',
    related_places: ['edinburgh-castle'],
  },
  {
    id: 'fallback-news-3',
    slug: 'voices-from-local-historians',
    title: 'Voices from Local Historians',
    summary: 'Hear regional researchers explain why certain archives, trails, or rituals matter now.',
    body: `The Hexham Historical Society digitised its first tranche of oral histories, capturing how families in the
Tyne Valley rotated custody of border ballads. We sat down with their volunteer editor to map the recording process
from farmhouse kitchens to the public listening room.

If you have a community project that deserves a signal boost, send us a note with three bullet highlights and we will
feature it in this rolling dispatch.`,
    published_at: '2025-11-29T11:30:00Z',
    metadata: {
      place_slug: 'hadrians-wall',
      place_name: "Hadrian's Wall",
    },
    hero_image: 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1200&q=60',
    related_places: ['hadrians-wall'],
  },
]

export const NEWS_FALLBACK_CONTENT = FALLBACK_CONTENT

export const NEWS_FALLBACK_ITEMS: NewsCardItem[] = NEWS_FALLBACK_CONTENT.map((item) =>
  toNewsCardItem(item, item.slug ? `/news/${item.slug}` : '/news'),
)

export const getNewsFallbackBySlug = (slug: string): ContentItem | null => {
  return NEWS_FALLBACK_CONTENT.find((entry) => entry.slug === slug) ?? null
}
